(function(){
    'use strict'

    angular.module('app.usuarios')
    .factory('UsuariosService', UsuariosService);

    UsuariosService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function UsuariosService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update: update,
            remove: remove,
            changePassword: changePassword
        };

        return api;

        function getAll(clientId){

            var url = apiSettings.apiBaseUrl + 'api/usuarios/' + clientId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(clientId, usuarioId){

            var url = apiSettings.apiBaseUrl + 'api/usuarios/' + clientId + '/' + usuarioId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(usuario){

            if(!usuario.clienteId){
                usuario.clienteId = UserInfoService.getCliente();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios',  
                method: 'POST',  
                data: usuario
            });  
            return response;
        };

        function update(usuario){

            if(!usuario.clienteId){
                usuario.clienteId = UserInfoService.getCliente();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios',  
                method: 'PUT',  
                data: usuario
            });  
            return response;
        };

        function remove(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: usuario
            });  
            return response;
        };

        function changePassword(usuario){

            if(!usuario.clienteId){
                usuario.clienteId = UserInfoService.getCliente();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios/change-password',  
                method: 'PUT',  
                data: usuario
            });  
            return response;
        };

    };

})();